import { createSlice } from "@reduxjs/toolkit";

interface ILoaderProps {
  isLoading: boolean;
}

const initialState: ILoaderProps = {
  isLoading: false,
};

export const loaderSlice = createSlice({
  name: "loaderSlice",
  initialState,
  reducers: {
    hideLoader: (state) => {
      state.isLoading = false;
    },
    showLoader: (state) => {
      state.isLoading = true;
    },
    clearLoader: (state) => {
      state.isLoading = false;
    },
  },
});

export const { hideLoader, showLoader, clearLoader } = loaderSlice.actions;
